/**
 * Obtener el texto de unidad formateado según unitOfMeasurement
 * @param unitOfMeasurement - Unidad de medida del producto (ej: "m²", "caja", "unidad", "pallet")
 * @returns Texto formateado de la unidad
 */
export function formatUnit(unitOfMeasurement: string | null | undefined): string {
  if (!unitOfMeasurement) {
    return "unidades";
  }

  const normalized = unitOfMeasurement.toLowerCase().trim();

  // Unidades comunes
  if (normalized === "m²" || normalized === "m2" || normalized === "m^2") {
    return "m²";
  }

  if (normalized === "caja" || normalized === "cajas") {
    return "cajas";
  }

  if (normalized === "unidad" || normalized === "unidades") {
    return "unidades";
  }

  if (normalized === "pallet" || normalized === "pallets" || normalized === "palé") {
    return "pallets";
  }

  // Si no coincide con ninguna unidad común, usar el valor original
  return unitOfMeasurement;
}

/**
 * Obtener el texto singular de la unidad
 * @param unitOfMeasurement - Unidad de medida del producto
 * @returns Texto singular de la unidad
 */
export function formatUnitSingular(unitOfMeasurement: string | null | undefined): string {
  if (!unitOfMeasurement) {
    return "unidad";
  }

  const normalized = unitOfMeasurement.toLowerCase().trim();

  if (normalized === "m²" || normalized === "m2" || normalized === "m^2") {
    return "m²";
  }

  if (normalized === "caja" || normalized === "cajas") {
    return "caja";
  }

  if (normalized === "unidad" || normalized === "unidades") {
    return "unidad";
  }

  if (normalized === "pallet" || normalized === "pallets" || normalized === "palé") {
    return "pallet";
  }

  return unitOfMeasurement;
}

/**
 * Determinar si la unidad de medida es compatible con cálculo por m²
 * @param unitOfMeasurement - Unidad de medida del producto
 * @returns true si se puede calcular por m² (conversión de m² a otra unidad)
 * 
 * NOTA: Si el producto se vende en m², no tiene sentido calcular m² a m²,
 * solo tiene sentido calcular m² para productos que se venden en otras unidades (cajas, unidades, etc.)
 */
export function canCalculateBySquareMeters(unitOfMeasurement: string | null | undefined): boolean {
  if (!unitOfMeasurement) {
    return false;
  }

  const normalized = unitOfMeasurement.toLowerCase().trim();

  // Si la unidad es m², NO tiene sentido calcular m² (ya está en m²)
  if (normalized === "m²" || normalized === "m2" || normalized === "m^2") {
    return false;
  }

  // Para otras unidades (caja, unidad, pallet, etc.), sí tiene sentido calcular m²
  // El usuario puede ingresar m² y convertirlo a la unidad correspondiente
  return true;
}

